export enum ActionTypes {
  GET_ALERTS = '[Alert] GetAlerts',
  ADD_ALERT = '[Alert] Add',
  RESOLVE_ALERT = '[Alert] Resolve'
}

export class AddAlerts {
  static readonly type = ActionTypes.ADD_ALERT;

  constructor(public payload: any) {
  }
}

export class GetAlerts {
  static readonly type = ActionTypes.GET_ALERTS;
}

export class ResolveAlert {
  static readonly type = ActionTypes.RESOLVE_ALERT;

  constructor(public payload: { alertId: string }) {
  }
}
